import { useEffect } from 'react';

import { createLogGA } from '@/utils/analytics/logGA';

import { isMac } from '../utils/search-utils/searchUtils';

const logGA = createLogGA('Search');

interface UseSearchHotkeyProps {
  onPress: () => void;
  location: 'landingPage' | 'assetPageHeader';
  companyPage: string;
}
export const useSearchHotkey = ({
  onPress,
  location,
  companyPage,
}: UseSearchHotkeyProps) => {
  useEffect(() => {
    const onKeyPress = (event: KeyboardEvent) => {
      const isPressed =
        event.code === 'KeyK'
          ? isMac()
            ? event.metaKey
            : event.ctrlKey
          : false;
      if (isPressed) {
        logGA('press_cmd_plus_k', { location, companyPage });
        event.preventDefault();
        onPress();
      }
    };

    document.addEventListener('keydown', onKeyPress);
    return () => {
      document.removeEventListener('keydown', onKeyPress);
    };
  }, []);
};
